import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {FlowPageDataProduct, FlowSummary, QuestionFlowCollation} from '../../models/quote.model';
import {QuestionFlowSessionQuery} from '../state/question-flow-session.query';
import {FlowPlayerService} from '../../services/flow-player.service';
import {QuestionQuery} from '../state/question.query';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {Alert} from '../../../shared/utilities';
import { UserStore } from 'src/app/modules/authentication/state/user.store';
import { ComponentsService } from '../../services/components-service';
import { SuperflowStore } from '../state/superflow.store';
import { StorageService } from 'src/app/modules/shared/services/storage.service';

declare var $: any;

@Component({
    selector: 'app-question-summary',
    templateUrl: './question-summary.component.html',
    styleUrls: ['./question-summary.component.scss'],
    standalone: false
})
export class QuestionSummaryComponent implements OnInit, OnChanges, OnDestroy {

  @Input() question: Question;
  @Output() questionAnswer = new EventEmitter<any>();
  @Output() submitResponse = new EventEmitter<any>();
  @Output() showEditModal = new EventEmitter<any>();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSummaryDataChanged = new EventEmitter<any>();

  collations: QuestionFlowCollation[] = [];
  summaryCollations: QuestionFlowCollation[] = [];
  product: FlowPageDataProduct;
  summary = new FlowSummary();
  sessionDetails: any;
  selectedItem: any;
  classes: QuestionFlowCollation[] = [];
  classItems: any[] = [];
  isSavingData = false;
  parameter: any;
  itk = '';
  summaryDataSubscription: Subscription;
  recommendation: any;
  user: any;
  window: any['dataLayer'] = window['dataLayer'] || [];
  selectedRecommendation: any
  constructor(
    public questionService: GlobalQuestionService,
    private flowPlayer: FlowPlayerService,
    private ref: ChangeDetectorRef,
    private router: Router,
    private userStore: UserStore,
    private QuestionQuery: QuestionQuery,
    private superflowStore: SuperflowStore,
    private componentsService: ComponentsService,
    private storageService: StorageService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery) {
    this.sessionDetails = this.questionFlowSessionQuery.getValue();
  }


  ngOnInit(): void {
    this.user = this.userStore.getValue();
    try {
      this.parameter = JSON.parse(this.question.parameter);
    } catch (e) { }

    this.summaryDataSubscription = this.questionService.summaryData
      .subscribe(v => {
        if (v) {
          if (!this.isSavingData) {
            this.getPageData();
          }
          this.questionService.setSummaryDataObservable(false);
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;

      this.getITK();

      if (!this.isSavingData) {
        this.getPageData();
      }
    }
  }

  getITK(): void {
    let itk = '';

    try { // check itk
      const json = JSON.parse(this.question.itk);
      itk = json.filter((item: any) => item.answer === this.question.answer)[0]?.itk_comment;
      if (!itk) {
        itk = json.filter((item: any) => item.answer_id === 0)[0]?.itk_comment;
      }
    }
    catch (e) { }
    this.itk = itk;
  }

  getPageData(): void {
    if (this.question) {
      //this.questionService.spinner(true);
      this.questionService.spinnerTransparent(true);
      this.isSavingData = true;
      this.summaryCollations = [];
      this.classes = [];
      this.questionService.updatePrices(this.question?.product_id, this.question.product_class_id, 0)
        .subscribe(x => {
          this.questionService.getPageData('summary')
            .subscribe(dataset => {
              
              this.product = this.questionService.getIndexData(4, dataset)[0];
              this.collations = this.questionService.getIndexData(2, dataset);
              this.recommendation = this.questionService.getIndexData(8, dataset);
              this.classes = this.collations.filter(item => item.entry_type === 'class_total' && item.mandatory !== 1 && item.frequency_id === this.questionService?.currency.frequency_id && item?.product_id === this.question?.product_id);
              this.summary.pageDataProduct = this.product;
              this.summary.person = this.questionService.getIndexData(1, dataset)[0];
              this.summary.collations = this.collations;
              this.onSummaryDataChanged.emit({collations: this.collations, product: this.product});
              this.setupCollation();
              let brokerType = 'Direct';
              if (this.user?.broker_id > 0 || this.storageService.get('partner_code', 'flow')) brokerType = 'Partner';
              try{
                this.window.push({
                  event: 'reachedSummaryPage',
                  category:  this.sessionDetails?.css,
                  sessionID: this.sessionDetails?.session_id,
                  product: this.product.product_name,
                  brokerType: brokerType,
                  referrerCode: this.storageService.get('referrer_code', 'flow')
                });
              }
              catch{}

            }, error => {
              //this.questionService.spinner(false);
              this.questionService.spinnerTransparent(false);
              this.isSavingData = false;
              Alert("An error has occurred.", 5000);
            });
        }, error => {
          //this.questionService.spinner(false);
          this.questionService.spinnerTransparent(false);
          this.isSavingData = false;
          Alert("An error has occurred.", 5000);
        });
    }
  }

  setupCollation(): void {
    if (this.question) {
      for (const c of this.collations) {
        if (c.product_id === this.question.product_id && c.entry_type === 'item' && c.frequency_id === 3 && c.mandatory !== 1) {
          c.discountList = [];
          const discountList = c.discounts.split(',');
          for (const item of discountList) {
            const dl = item.split(':');
            if (dl[1]) {
              c.discountList.push(dl[1]);
            }
          }
          this.summaryCollations.push(c);
        }
      }
      this.question.answer = 'continue';
      try { this.question.answer = this.parameter[0]?.value; } catch (e) { }
      this.questionAnswer.emit(this.question);
      this.questionService.setShoppingCart(this.question, '0');
      this.isSavingData = false;
      //this.questionService.spinner(false);
      this.questionService.spinnerTransparent(false);
    }
    if (this.summaryCollations.length === 0) {
      //this.questionService.spinner(false);
      this.questionService.spinnerTransparent(false);
      Alert("There is currently no data to show.", 2000);
      //this.question.answer = 'add_another';
      //this.submitResponse.next(undefined);
    }
  }

  getItems(class_id: number): any {
    return this.summaryCollations.filter((item: { class_id: number }) => item.class_id === class_id);
  }

  editItem(collation: QuestionFlowCollation): void {
    //console.log(collation)
    this.showEditModal.emit({
      collations: this.collations,
      collation,
      product: this.product,
      person: this.summary.person,
      path: '3'
    });

    let allQuestions = this.QuestionQuery.getAllQuestions();
    const main_session = {
      session: this.sessionDetails,
      question: this.question,
      questions: allQuestions,
      active_class_id: collation.class_id,
      current_page: 'summary',
    };
    
    this.storageService.setJson('main_session', main_session, 'flow');
  }
  checkAddAnother(): boolean {
    try {
      if (this.parameter[1]?.value === 'add_another') {
        return true;
      }
      else {
        return false;
      }
    }
    catch {
      return false;
    }
  }
  gotToNext(): void {
    var a = '';
    try { a = this.parameter[1]?.value } catch (e) { };
    this.question.answer = a;
    this.submitResponse.next(undefined);
  }
  getRecommendation(item: any, class_level: boolean = false): any {
   
    let result: any = [];
     if (class_level) {
        result = this.recommendation.filter(i => i.class_id === item?.class_id && !i.item_id);
     }
     else {
      result = this.recommendation.filter(i => i.class_id === item?.class_id && i.item_id === item.session_item_id);
     }
    return result;
  }
  popUpRecommendation(recommend: any): void {
     this.selectedRecommendation = recommend;
     this.componentsService.setDiscountFlow(this.selectedRecommendation);
     $('#modal-discount-flow').modal('show')
  }
  startFlow(): void {
    console.log(this.selectedRecommendation);
    
  }
  ngOnDestroy(): void {
    this.summaryDataSubscription.unsubscribe();
  }
}
